var map = {
	"./One.svg": 2761,
	"./arrow-down.svg": 6613,
	"./arrow-left.svg": 2957,
	"./arrow-up.svg": 3639,
	"./ema-orb.svg": 6470,
	"./girl-headphones.png": 2187,
	"./myuti-arrow-right.png": 4622,
	"./myuti-bubble.png": 2564,
	"./myuti-close.png": 4023,
	"./myuti-mya.png": 4288,
	"./myuti-send-2.png": 1202,
	"./myuti-send.png": 4001,
	"./myuti-user.png": 3200,
	"./option-not-selected.svg": 3724,
	"./option-selected.svg": 3699,
	"./orb.png": 7908,
	"./paperplaneleft.svg": 423,
	"./plane.svg": 8137,
	"./send_1.png": 600,
	"./send_2.png": 7608,
	"./thumbs-down.svg": 6018,
	"./thumbs-up.svg": 103,
	"./userIcon.svg": 4093
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9536;